import {
  RelatedProductCandidate,
  relatedProductCandidateFromResponse,
} from './RelatedProductCandidate';

export interface RelatedProductsResponse {
  candidates: RelatedProductCandidate[];
  relatedProductIDs: number[];
}

export const relatedProductsResponseFromResponse = (
  responseData: any,
): RelatedProductsResponse => ({
  candidates: (responseData.candidates ?? []).map((candidate: any) =>
    relatedProductCandidateFromResponse(candidate),
  ),
  relatedProductIDs: responseData.related_product_ids ?? [],
});
